export default __webpack_public_path__ + "static/media/Sharjah-Research-Technology-and-Innovation-Park.5578b523.mp4";